import { defineStore } from 'pinia';
// import type { UserInfo } from '@/types/menu';
import { login as userLogin, getUserInfo, type PassportInfo, type LoginParams, type TokenResponse } from '@/api/user';

interface UserState {
  name?: string;
  avatar?: string;
  job?: string;
  organization?: string;
  location?: string;
  email?: string;
  introduction?: string;
  personalWebsite?: string;
  jobName?: string;
  organizationName?: string;
  locationName?: string;
  phone?: string;
  registrationDate?: string;
  accountId?: string;
  certification?: string;
  role: string;
  userInfo: PassportInfo | null;
}

const setToken = (token: string) => {
  localStorage.setItem('token', token);
};

const clearToken = () => {
  localStorage.removeItem('token');
};

export const useUserStore = defineStore('user', {
  state: (): UserState => ({
    name: undefined,
    avatar: undefined,
    job: undefined,
    organization: undefined,
    location: undefined,
    email: undefined,
    introduction: undefined,
    personalWebsite: undefined,
    jobName: undefined,
    organizationName: undefined,
    locationName: undefined,
    phone: undefined,
    registrationDate: undefined,
    accountId: undefined,
    certification: undefined,
    role: '',
    userInfo: null,
  }),

  getters: {
    getUserProfile(state: UserState): PassportInfo | null {
      return state.userInfo;
    },
  },

  actions: {
    // Set user's information
    setInfo(partial: Partial<PassportInfo>) {
      if (partial) {
        this.userInfo = {
          ...this.userInfo,
          ...partial
        } as PassportInfo;
      }
    },

    // Reset user's information
    resetInfo() {
      this.$reset();
    },

    // Get user's information
    async info() {
      const res = await getUserInfo();
      this.setInfo(res);
    },

    // Login
    async login(loginData: LoginParams, captchaKey: string): Promise<TokenResponse> {
      try {
        const res = await userLogin(loginData, captchaKey);
        setToken(res.data.access_token);
        return res.data;
      } catch (err) {
        clearToken();
        throw err;
      }
    },

    async getUserInfo() {
      try {
        const data = await getUserInfo();
        // 设置用户基本信息
        this.name = data.nick_name;
        this.phone = data.telephone;
        this.role = String(data.role_id);
        // 设置完整的用户信息
        this.userInfo = data;
        return data;
      } catch (error) {
        this.userInfo = null;
        return null;
      }
    },

    logout() {
      clearToken();
      this.userInfo = null;
      this.name = undefined;
      this.avatar = undefined;
      this.role = '';
      this.phone = undefined;
    },
  },
});
